import React from 'react';
import { FormControl, TextField, InputAdornment } from '@material-ui/core';
import MailOutline from '@material-ui/icons/MailOutline';

import { ControlContainer } from 'app/components/ControlContainer';
import { TravelFormEMailControlProps } from './TravelFormEMailControl.interfaces';
import { LabelEnum } from 'app/shared/enums';
import { useEmailControl } from 'app/shared/hooks/controls/useEmailControl';
import { useStyles } from './TravelFormEMailControl.styles';

export default function TravelFormEMailControl(
  props: TravelFormEMailControlProps
) {
  const classes = useStyles();

  const { disabled, input, meta, subLabel, helperText, width } = props;
  const label = LabelEnum.EnterYourEmailAddressToBeAbleToGetBackToOffers;

  const {
    error,
    focused,
    handleBlur,
    handleChange,
    handleClick,
    onFocus,
  } = useEmailControl(props);

  return (
    <FormControl fullWidth>
      <ControlContainer
        inputId={input.name}
        label={label}
        subLabel={subLabel}
        helperText={helperText}
        floating
        floated
        focused={focused}
        meta={meta}
        classes={{ controlWrapper: classes.controlWrapper }}
        width={width}
      >
        <div className={classes.text}>
          {LabelEnum.YouWontGetAnyUnwantedAdsFromUs}
        </div>
        <TextField
          {...input}
          id={input.name}
          fullWidth
          disabled={disabled}
          InputProps={{
            className: classes.textField,
            startAdornment: (
              <InputAdornment position="start">
                <MailOutline className={classes.icon} />
              </InputAdornment>
            ),
          }}
          onChange={handleChange}
          onBlur={(event) => handleBlur(event.target.value)}
          onClick={handleClick}
          onFocus={onFocus}
          error={error}
          variant="outlined"
          margin="dense"
          placeholder={LabelEnum.EmailPlaceholder}
        />
      </ControlContainer>
    </FormControl>
  );
}
